export function LogoMark({ size = 44, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="Logo Associazione Vittime del Debito"
      className={className}
    >
      <circle cx="32" cy="8" r="2.6" fill="#4db8a0" />
      <path d="M32 12v34" stroke="#4db8a0" strokeWidth="5" strokeLinecap="round" />
      <path d="M10 20h44" stroke="#4db8a0" strokeWidth="5" strokeLinecap="round" />
      <circle cx="10" cy="20" r="2.2" fill="#4db8a0" />
      <circle cx="54" cy="20" r="2.2" fill="#4db8a0" />
      <path d="M10 20l-4 12 M10 20l4 12" stroke="#4db8a0" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M54 20l-4 12 M54 20l4 12" stroke="#4db8a0" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M4 32.5a6 6 0 0 0 12 0" stroke="#4db8a0" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M48 32.5a6 6 0 0 0 12 0" stroke="#4db8a0" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M26 50h12" stroke="#4db8a0" strokeWidth="5" strokeLinecap="round" />
      <path d="M21 56h22" stroke="#4db8a0" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ dark = false, size = 48 }) {
  return (
    <span className="flex items-center gap-3" data-testid="site-logo">
      <LogoMark size={size} className="shrink-0" />
      <span className="leading-tight">
        <span
          className={`block font-extrabold text-xl tracking-tight ${dark ? "text-white" : "text-brand-blue"}`}
        >
          Vittime del Debito
        </span>
        <span className="block text-xs font-semibold text-brand-aqua mt-0.5">
          Informazione e assistenza gratuita
        </span>
      </span>
    </span>
  );
}
